<template>
  <router-view />
  <!-- One global notice while the API is unreachable — most often a release in flight,
       where this static site keeps serving while the API's app pool is stopped. -->
  <ApiOfflineOverlay />
</template>

<script>
import ApiOfflineOverlay from "@/components/ApiOfflineOverlay.vue";

export default {
  name: "App",
  components: { ApiOfflineOverlay },
};
</script>
